import React, { useState } from "react"

import MasterPage from './MasterPage';

export default function Crawl(props) {
     return (               
         <MasterPage />
    )
}